import AuthAPI from '@/apis/business/account/auth-api.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * Đổi mật khẩu
     * @param {*} context
     * @param {*} params
     * @returns
     */
    changePassword (context, params) {
      return AuthAPI.postAsync('password/change', params)
    },
    /**
     * Lấy link đăng nhập MisaId
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getLinkMisaID (context, actionName) {
      return AuthAPI.postAsync('generatelinklogin', { ActionName: actionName })
    }
  }
}
